(() => {
  function initSticky() {
    // 1) Seulement si on a un product-form
    const form = document.querySelector('product-form') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const originalSubmit = form.querySelector('button[type="submit"]');
    if (!originalSubmit) return;

    // 2) Crée le container sticky
    const sticky = document.createElement('div');
    sticky.id = 'sticky-scroll-to-form';

    // 3) Clone natif du bouton pour garder le style
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'sticky-scroll-button';
    btn.className = originalSubmit.className;
    btn.innerHTML = originalSubmit.innerHTML;
    sticky.append(btn);
    document.body.append(sticky);

    // 4) Observer pour n’afficher le sticky que quand le bouton natif n’est PAS visible
    const io = new IntersectionObserver(entries => {
      const onScreen = entries[0].isIntersecting;
      // si drawer open (body.hidden) ou bouton natif visible → on cache
      if (onScreen || document.body.classList.contains('hidden')) {
        sticky.classList.remove('show');
      } else {
        sticky.classList.add('show');
      }
    }, { threshold: 0 });
    io.observe(originalSubmit);

    // 5) On surveille body.hidden (drawer open) pour cacher instantanément
    new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === 'class') {
          if (document.body.classList.contains('hidden')) {
            sticky.classList.remove('show');
          } else {
            // si le native button est déjà en‑vue, on reste caché
            const rect = originalSubmit.getBoundingClientRect();
            if (!(rect.bottom > 0 && rect.top < window.innerHeight)) {
              sticky.classList.add('show');
            }
          }
        }
      });
    }).observe(document.body, { attributes: true });

    // 6) Clic → scroll centré sur tout le form (titre + variantes + bouton), +15px en plus
    btn.addEventListener('click', e => {
      e.preventDefault();
      const rect = form.getBoundingClientRect();
      const centerScroll = window.scrollY
        + rect.top
        - (window.innerHeight / 2)
        + (rect.height / 2)
        - 100;   // 15px de marge en plus
      window.scrollTo({ top: centerScroll, behavior: 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky, { once: true });
  } else {
    initSticky();
  }
})();
